<template>
  <v-dialog persistent v-model="visible" @keydown.esc="close" max-width="500px">
    <v-card :loading="loading">
      <v-card-title>
        <span class="headline">筛选</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-autocomplete
              label="用户"
              item-text="realName"
              item-value="name"
              multiple
              v-if="users && users.length !== 0"
              :readonly="loading"
              :items="users"
              v-model="params.filters.userNames"
              @change="initMarket"/>
          <v-autocomplete
              label="平台"
              item-text="name"
              item-value="code"
              multiple
              :readonly="loading"
              :items="marketplaces"
              v-model="params.filters.marketplaces"
              @change="initStore"/>
          <v-autocomplete
              label="店铺"
              multiple
              :readonly="loading"
              :menu-props="{ maxHeight: '400' }"
              :items="stores"
              v-model="params.filters.stores"
              @change="initAsin"/>
          <v-autocomplete
              label="ASIN"
              multiple
              :readonly="loading"
              :items="asins"
              v-model="params.filters.asins"
              @change="initSku"/>
          <v-autocomplete
              label="SKU"
              multiple
              :readonly="loading"
              :menu-props="{ maxHeight: '400' }"
              :items="skus"
              v-model="params.filters.skus"/>
          <v-autocomplete
              label="状态"
              multiple
              v-if="status"
              :readonly="loading"
              v-model="params.filters.statuses"
              :items="statuses"
              :menu-props="{ maxHeight: '400' }"/>
          <v-row v-if="itemCount">
            <v-col cols="6">
              <v-text-field v-model="params.filters.minOrderItemCount" label="商品数量(最小值): "/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="params.filters.maxOrderItemCount" label="商品数量(最大值): "/>
            </v-col>
          </v-row>
          <v-row v-if="dateRange">
            <v-col cols="6">
              <v-text-field type="date" label="开始日期" v-model="params.filters.beginTime"/>
            </v-col>
            <v-col cols="6">
              <v-text-field type="date" label="结束日期" v-if="endTimeEnabled" v-model="params.filters.endTime"/>
              <v-switch v-else v-model="endTimeEnabled" label="结束时间"/>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="reset">重置</v-btn>
        <v-btn color="blue darken-1" text :loading="loading" @click="save">保存</v-btn>
        <v-btn color="blue darken-1" text @click="close">取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TodayFilter",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: null,
    dateRange: {
      type: Boolean,
      default: false
    },
    itemCount: {
      type: Boolean,
      default: false
    },
    status: {
      type: Boolean,
      default : false
    }
  }, computed: {
    loading() {
      return this.load.userLoading || this.load.marketLoading || this.load.storeLoading
          || this.load.asinLoading || this.load.skuLoading;
    }
  }, data() {
    return {
      initFlag: false,
      load: {},
      endTimeEnabled: false,
      users: [],
      marketplaces: [],
      stores: [],
      asins: [],
      skus: [],
      statuses: ["Pending", "Shipped", "Canceled", "Unshipped"]
    }
  }, methods: {
    init() {
      console.debug("开始初始化TodayFilter");
      this.initFlag = true;

      this.load = {
        userLoading: false,
        marketLoading: false,
        storeLoading: false,
        asinLoading: false,
        skuLoading: false
      }
    },
    initUser() {
      this.load.userLoading = true;
      this.$axios.get("/group/members").then(
          response => {
            this.load.userLoading = false;
            this.users = response.data;
            console.debug("获得所有成员: ", response);
            this.initMarket();
          }
      );

    }, initMarket() {
      this.load.marketLoading = true;
      this.$axios.get("/stores/marketplace", {
        params: {
          userNames: this.params.filters.userNames
        },
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.load.marketLoading = false;
            this.marketplaces = response.data;
            this.initStore();
          }
      );
    }, initStore() {
      this.load.storeLoading = true;
      console.debug("开始拉取店铺, 指定的平台为: ", this.params.filters.marketplaces);
      this.$axios.get("/stores/name", {
        params: {
          marketplaces: this.params.filters.marketplaces,
          userNames: this.params.filters.userNames
        },
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.load.storeLoading = false;
            this.stores = response.data;
            this.params.filters.stores = [];
            this.params.filters.asins = [];
            this.params.filters.skus = [];
            this.initAsin();
          }
      );
    },
    initAsin() {
      this.load.asinLoading = true;
      this.$axios.get("/products/asin", {
        params: {
          stores: this.params.filters.stores,
          userNames: this.params.filters.userNames
        },
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.load.asinLoading = false;
            this.asins = response.data;
            this.params.filters.asins = [];
            this.params.filters.skus = [];
            this.initSku();
          }
      );
    },
    initSku() {
      this.load.skuLoading = true;
      this.$axios.get("/products/sku", {
        params: {
          stores: this.params.filters.stores,
          asins: this.params.filters.asins,
          userNames: this.params.filters.userNames
        },
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.load.skuLoading = false;
            this.skus = response.data;
            this.params.filters.skus = [];
          }
      );
    },
    save() {
      this.close();
      this.$emit("reload");
      this.$bus.$emit("clearStat");
    }, reset() {

    }, close() {
      this.$emit("update:visible", false);
    },
  }, mounted() {
  }, watch: {
    visible: {
      handler() {
        console.debug("TodayFilter状态: ", this.visible);
        if (this.visible) {
          if (!this.initFlag) {
            this.init();
          }
          this.initUser();
        }
      }
    }
  }
}
</script>

<style scoped>

</style>